import { ReservationSelectedBookingContext } from '../Types/reservationBookingContext.types';

/**
 * Returns offerId from selected booking context hydrated by bookingId.
 * @param selectedBookingContext - Selected booking context from by-id query.
 * @returns The offerId of the selected booking, or undefined if unavailable.
 */
export function getOfferIdFromBookings(
  selectedBookingContext: ReservationSelectedBookingContext | undefined
): number | undefined {
  return selectedBookingContext?.offerId;
}
